const WasteManagementAdminHome = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2346_7385)" />
      <g clip-path="url(#clip0_2346_7385)">
        <path
          d="M47.75 38L46.25 37.125C44.625 36.125 44.625 33.75 46.25 32.75L47.75 31.875C49 31.125 49.375 29.625 48.625 28.5L47.375 26.375C46.625 25.125 45.125 24.75 44 25.5L42.5 26.375C40.875 27.375 38.75 26.125 38.75 24.25V22.5C38.75 21.125 37.625 20 36.25 20H33.75C32.375 20 31.25 21.125 31.25 22.5V24.125C31.25 26 29.125 27.25 27.5 26.25L26.0001 25.5C24.7501 24.75 23.25 25.25 22.625 26.375L21.375 28.5C20.75 29.75 21.125 31.25 22.25 32L23.75 32.875C25.375 33.75 25.375 36.25 23.75 37.125L22.25 38C21 38.75 20.625 40.25 21.375 41.375L22.625 43.5C23.375 44.75 24.8751 45.125 26.0001 44.375L27.5 43.625C29.125 42.625 31.25 43.875 31.25 45.75V47.5C31.25 48.875 32.375 50 33.75 50H36.25C37.625 50 38.75 48.875 38.75 47.5V45.875C38.75 44 40.875 42.75 42.5 43.75L44 44.625C45.25 45.375 46.75 44.875 47.375 43.75L48.625 41.625C49.25 40.25 48.875 38.75 47.75 38ZM35 40C32.25 40 30 37.75 30 35C30 32.25 32.25 30 35 30C37.75 30 40 32.25 40 35C40 37.75 37.75 40 35 40Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2346_7385"
          x1="34.5455"
          y1="0"
          x2="34.5455"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF005C" />
          <stop offset="1" stop-color="#BD0044" />
        </linearGradient>
        <clipPath id="clip0_2346_7385">
          <rect width="30" height="30" fill="white" transform="translate(20 20)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default WasteManagementAdminHome
